<template>
  <div class="project EOPPBlock" v-if="oe.hasProjects">
    <div class="green-gradient"></div>
    <h1 class="card-title has-text-weight-bold has-text-zero">
      PROJETOS
    </h1>
    <slot></slot>
    <p class="card-content has-text-zero">{{ oe.projects }}</p>
  </div>
</template>

<script>
export default {
  name: "Projects",
  props: ["oe"]
};
</script>

<style>
.project {
  position: relative;
  min-height: 18rem;
  margin-top: 0.5rem;
}

.green-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 18rem;
  height: 17rem;
  background: linear-gradient(#02f8c7, #ffffff 95%);
  clip-path: polygon(50% 0%, 0% 0%, 0% 100%, 100% 100%);
  z-index: 5;
  border-top-left-radius: 0.5rem;
}

.card-title {
  position: relative;
  padding-left: 3rem;
  font-size: 4rem;
  margin-top: 3rem;
  margin-bottom: 0;
  z-index: 10;
}

.card-content {
  position: relative;
  padding-top: 0;
  padding-left: 3rem;
  font-size: 1.2rem;
  margin-bottom: 3rem;
  z-index: 10;
}

.botao:hover {
  cursor: pointer;
  transform: scale(1.1);
  transition: ease-in-out 0.1s;
}

.botao2 {
  position: absolute;
  right: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
}

.botao2:hover {
  cursor: pointer;
  transform: scale(1.1);
  transition: ease-in-out 0.1s;
}

@media (max-width: 460px) {
  .card-content,
  .card-title {
    padding-left: 1rem !important;
  }
  .card-title {
    font-size: 3rem !important;
  }
  .card-content {
    font-size: 1rem !important;
  }
  .botao {
    margin-top: 0.5rem !important;
  }
}
</style>
